export default __webpack_public_path__ + "media/images/landlords_page/benefits_3-f321cc9d4139e7f32b1165574260db0f.webp";